import { IframeDialogClosed, OpenIframeDialog } from "@components/utils/IframeDialog/events";

/**
 * Singleton to track game iframe dialog open status via window events.
 * Avoids DOM queries (querySelector, getComputedStyle, offsetWidth) that cause forced layout and hurt INP.
 */
export class GameIframeStateTracker {
  private static instance: GameIframeStateTracker | null = null;
  private isGameOpen = false;

  private readonly handleOpen = (e: Event) => {
    const customEvent = e as CustomEvent<{ options?: { isGame?: boolean } }>;
    if (customEvent.detail?.options?.isGame) {
      this.isGameOpen = true;
    }
  };

  private readonly handleClose = (e: Event) => {
    const customEvent = e as CustomEvent<{ options?: { isGame?: boolean } }>;
    if (customEvent.detail?.options?.isGame) {
      this.isGameOpen = false;
    }
  };

  private constructor() {
    window.addEventListener(OpenIframeDialog, this.handleOpen);
    window.addEventListener(IframeDialogClosed, this.handleClose);
  }

  static getInstance(): GameIframeStateTracker {
    if (!GameIframeStateTracker.instance) {
      GameIframeStateTracker.instance = new GameIframeStateTracker();
    }
    return GameIframeStateTracker.instance;
  }

  isOpen(): boolean {
    return this.isGameOpen;
  }

  reset(): void {
    this.isGameOpen = false;
  }

  cleanup(): void {
    window.removeEventListener(OpenIframeDialog, this.handleOpen);
    window.removeEventListener(IframeDialogClosed, this.handleClose);
  }
}

// Eager init so listeners register at module load, before any user-driven
// OpenIframeDialog can fire. No circular import, no TDZ.
GameIframeStateTracker.getInstance();
